const de: any = {
  /**
   * General
   */

  home: 'Startseite',
  language: 'Sprache',
  readOnlyNoPermission:
    'Sie haben nur Leserechte für dieses Formular. Änderungen können nur von einem Administrator vorgenommen werden.',
  login: 'Anmeldung',
  welcome: 'Willkommen ',
  homeIntro: 'Hier sehen Sie Ihre Mandanten, Prüfungen und Ihr verfügbare Punkte auf einen Blick.',
  yes: 'Ja',
  no: 'Nein',
  ok: 'OK',
  cancel: 'Abbrechen',
  proceed: 'Fortfahren',
  createdAt: 'Erstellt',
  updatedAt: 'Aktualisiert',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  confirmed: 'Bestätigt',
  unconfirmed: 'Unbestätigt',
  create: 'Erstellen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  restore: 'Wiederherstellen',
  deleteClient: 'Mandant löschen',
  markDeleted: 'Mandant löschen',
  pinCode: 'PIN-Code',
  pinCodeValidation: 'PIN-Code-Validierung',
  pinCodeSentMail: 'PIN-Code wurde Ihnen per Mail zugesandt.',
  areYouSure: 'Sind sie sicher?',
  fetching: 'Wird geladen...',
  error: 'Fehler!',
  Error: 'Fehler',
  serverError: 'Serverfehler',
  unknownError: 'Unbekannter Fehler',
  networkError: 'Server ist nicht erreichbar. Bitte versuchen Sie es später erneut.',
  previewError: 'Vorschau konnte nicht geladen werden.',
  companyInfoMissing:
    'Unternehmensdaten konnten nicht geladen werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
  pageNotFound: 'Seite nicht gefunden',
  invalidConfirmationUrl: 'Ungültige Bestätigungs-URL',
  forbbiden: 'Verboten',
  actions: 'Aktionen',
  status: 'Status',
  show: 'Übersicht',
  administration: 'Verwaltung',
  Clients: 'Mandanten',
  deleted: 'Gelöscht',
  noData: 'Keine Daten.',
  client: 'Mandant',
  /**
   * User
   */
  userCreated: 'Der Benutzer wurde erstellt.',
  userUpdated: 'Der Benutzer wurde aktualisiert.',
  userDeleted: 'Der Benutzer wurde gelöscht.',
  deleteUser: 'Löschen',
  resendConfirmationEmail: 'Aktivierungsmail erneut senden',
  userNotFound: 'Benutzer nicht gefunden',
  addUser: 'Erstellen',
  logout: 'Abmeldung',
  loginButton: 'Anmelden',
  getPasswordResetEmail: 'Zurücksetzen des Passworts',
  download: 'Herunterladen',
  submit: 'Senden',
  user: 'Benutzer',
  users: 'Benutzer',
  total: 'Gesamt',
  email: 'E-Mail-Adresse',
  phone: 'Telefon',
  password: 'Passwort',
  pincodeOptionNote: 'Sie müssen mindestens eine Option auswählen!',
  repeatPassword: 'Passwort wiederholen',
  setPassword: 'Passwort festlegen',
  forgotPassword: 'Passwort vergessen?',
  passwordResetEmailSent: 'Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.',
  logoFileTooLarge: 'Die Logodatei darf maximal 3 MB gross sein.',
  passwordRequirements: 'Passwortanforderungen',
  passwordReqLength: 'Mindestens 8 Zeichen',
  passwordReqCase: 'Gross- und Kleinbuchstaben',
  passwordReqNumber: 'Mindestens eine Zahl',
  passwordReqSymbol: 'Mindestens ein Sonderzeichen',
  verify: 'Verifizieren',
  isAdmin: 'ist Administrator',
  admin: 'Administrator',
  nonAdmin: 'Kein Administrator',
  twoFactor: 'Zwei-Faktor-Authentifizierung',
  recoveryCodes: 'Verwenden Sie einen Wiederherstellungscode',
  addAdditional: 'Erhöhen Sie die Sicherheit Ihres Kontos durch die Zwei-Faktor-Authentifizierung.',
  youHave: 'Du hast',
  enabledTwoFactor: 'Zwei-Faktor-Authentifizierung aktiviert',
  twoFactorEnabled: 'Die Zwei-Faktor-Authentifizierung ist aktiviert.',
  twoFactorDisabled: 'Es ist keine Zwei-Faktor-Authentifizierung aktiviert.',
  twoFactorDescription:
    'Wenn die Zwei-Faktor-Authentifizierung aktiviert ist, werden Sie während der Authentifizierung nach einem sicheren, zufällig generierten Token gefragt. Sie können dieses Token in der Authentifizierungs-App Ihres Smartphones abrufen.',
  enable: 'Aktivieren',
  disable: 'Deaktivieren',
  profile: 'Profil',
  profileInformation: 'Profilinformationen',
  updateProfile: 'Aktualisieren Sie Ihre Profilinformationen.',
  scanQRCode:
    'Um die Zwei-Faktor-Authentifizierung zu aktivieren, scannen Sie den folgenden QR-Code mit der Authentifizierungs-App Ihres Telefons oder geben Sie den Einrichtungsschlüssel ein und geben Sie den generierten OTP-Code ein.',
  confirm: 'Bestätigen',
  manualKey: 'Manueller Schlüssel: ',
  sixCode: '6-stelliger Code',
  fileUploaded: 'Datei hochgeladen',
  freeTrialEnded: 'Ihre kostenlose Testphase ist beendet.',
  pleaseSubscribe:
    'Sie können jetzt ein Abonnement abschliessen. Nach der Aktivierung Ihres Abonnements haben Sie ausserdem die Möglichkeit, jederzeit zusätzliche Guthaben zu erwerben.',
  Subscribe: 'Abonnieren',

  createAccount: 'Benutzerkonto erstellen',
  userCreate: 'Benutzer erstellen',
  userEdit: 'Benutzerbearbeitung',
  gender: 'Geschlecht',
  male: 'Herr',
  female: 'Frau',
  other: 'Herr/Frau',
  firstName: 'Vorname',
  lastName: 'Nachname',
  pinCodeOptions: 'PIN-Code über',
  lastAccess: 'Letzter Zugriff',
  company: 'Unternehmen',
  companyName: 'Firmenname',
  companyNameSubdomain: 'Unternehmensname',
  subdomainAlreadyTaken: 'Subdomain bereits vergeben!',
  teamSettings: 'Team Einstellungen',
  teamInfo: 'Name des Teams und Angaben zum Eigentümer',

  /**
   * Company
   */

  companyCreated:
    'Das Unternehmen wurde erfolgreich erstellt. Eine E-Mail zur Kontobestätigung wird an Ihre E-Mail-Adresse gesendet. Nachdem Sie Ihre E-Mail bestätigt haben, können Sie ein Passwort festlegen.',
  companyDataDownload: 'Daten',
  companyDeleteWarning:
    'Durch das Löschen werden alle Daten unwiderruflich entfernt. Eine Wiederherstellung ist nicht möglich.',
  companyDeleted: 'Firmenkonto löschen',
  selectPoints: 'Punkte auswählen',
  buyCredits: 'Kaufen Sie weitere Guthaben für KYC',
  purchaseCredits:
    'Erwerben Sie Guthaben für zusätzliche Signaturen. Sie können Ihr Guthaben für Folgendes verwenden',
  choosePlan:
    'Wählen Sie unten den passenden Tarif entsprechend der benötigten Guthabenmenge für die gewünschten Dienstleistungen aus.',
  usePoints: 'Nutzen Sie diese Punkte, um auf Funktionen zuzugreifen.',
  proceedPayment: 'Zur Zahlung weiter',
  availableCredits: 'Verfügbare Punkte',
  activeClients: 'Aktive Mandanten',
  amlChecksThisMonth: 'Prüfungen diesen Monat',
  otherServices: 'Sonstige',
  mustAgree: 'Sie müssen vor dem Absenden zustimmen.',
  agree: 'Ich stimme den',
  termsOfService: 'Allgemeinen Geschäftsbedingungen',
  privacyPolicy: 'Datenschutzhinweisen',
  and: 'und',
  register: 'Registrieren Sie sich',
  zu: 'zu.',
  /**
   * Validation
   */

  emailAddressAlreadyTaken: 'E-Mail-Adresse bereits vergeben.',
  invalidCompanyName: 'Ungültiger Firmenname',
  invalidSubdomain: 'Ungültige Subdomain',
  invalidFirstName: 'Ungültiger Vorname',
  invalidLastName: 'Ungültiger Nachname',
  invalidEmail: 'Ungültige E-Mail-Adresse',
  invalidPhone: 'Ungültige Telefonnummer',
  invalidPassword: 'Ungültiges Passwort',
  invalidPinCode: 'Ungültiger PIN-Code',
  invalidData: 'Ungültige Daten.',
  companyIsDeleted: 'Dieses Firmenkonto wurde gelöscht.',
  pinCodeExpired: 'Pin-Code abgelaufen.',
  accountLocked: 'Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es später erneut.',
  tooManyAttempts: 'Zu viele fehlgeschlagene Versuche. Bitte melden Sie sich erneut an.',

  pinCodeTitleSchufa: 'Risikoanalyse - Abgleich mit Sanktions-/ Watch-/Black-/PEP-Listen',
  kycServiceTitle: 'KYC Check - Risikoanalyse - Abgleich mit Sanktions-/ Watch-/Black-/PEP-Listen',
  error_order_documents: 'Die Anfrage konnte nicht erstellt werden. Problem melden',

  clientNumber: 'Nr.',
  searchKeyword: 'Suchbegriff',
  isPerson: 'Natürliche Person',
  filter: 'Filter',

  partner: 'Kanzleileitung/Partner',
  responsibility: 'Mandatsverantwortung',
  name: 'Nachname / Firmenname',
  nameBeneficial: 'Nachname',
  country: 'Land',
  lastCheck: 'Letzte Prüfung',
  numberChecks: 'Anzahl Prüfungen',
  dateOfBirth: 'Geburtsdatum',

  partialImport: 'Partieller Import',
  downloadData: 'Daten herunterladen',

  kycChecks: 'KYC-Prüfungen',
  amlChecks: 'AML-Prüfungen',
  kycChecksSaved: 'KYC-Prüfungen',
  kycChecksDeleted: 'KYC-Prüfungen gelöscht',

  Settings: 'Einstellungen',
  LogOut: 'Abmelden',
  companyDetails: 'Firmendetails',
  billing: 'Abrechnung',

  newClient: ' Neuer Mandant',
  search: 'Suchen',
  sort: 'Sortieren',
  noClientsFound: 'Keine Mandanten gefunden',

  created: 'Erstellt',
  updated: 'Aktualisiert',
  risik: 'Risiko',
  risikLow: 'Gering',
  risikMedium: 'Mittel',
  risikHigh: 'Hoch',
  risikUnknown: 'Unbekannt',
  credit: 'Kredit',
  credits: 'Punkte',
  stammdatenCostInfo: 'Das Erstellen eines Stammdatensatzes kostet 5 Punkte.',

  trialPeriodActive: 'Probezeit aktiv',
  trialMode: 'Sie verwenden die Anwendung derzeit im Testmodus.',
  trialExpiryInfo:
    'Sobald Ihre Probezeit abläuft oder Ihre Punkte aufgebraucht sind, können Sie ein Abonnement abschliessen oder zusätzliche Guthaben erwerben.',
  endTrialSubscribeTitle: 'Möchten Sie früher starten?',
  endTrialSubscribeInfo:
    'Sie können Ihre Probezeit jederzeit beenden und direkt ein Abonnement abschliessen. Ihre verbleibenden Testpunkte werden dabei auf Ihr Abonnement-Guthaben übertragen; die verbleibenden Testtage verfallen.',
  confirmEndTrialSubscribe:
    'Wenn Sie jetzt ein Abonnement abschliessen, endet Ihre Probezeit vorzeitig. Ihre verbleibenden Testpunkte werden auf Ihr Abonnement-Guthaben übertragen, die verbleibenden Testtage verfallen. Möchten Sie fortfahren?',
  startTrialOption: 'Kostenlose Probezeit starten',
  trialStarted: 'Ihre kostenlose Probezeit wurde aktiviert.',
  trialNotAvailable: 'Die kostenlose Probezeit kann nicht mehr gestartet werden.',
  trialStartError: 'Die Probezeit konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',

  days: 'Tage',
  remaining: 'bzw.',
  points: 'Punkte',
  pointsAvailable: 'Verfügbare Punkte',
  left: 'verbleibend',

  createNewClient: 'Neuen Mandanten erstellen',
  naturalPerson: 'Natürliche Person',
  emailAddress: 'E-Mail-Adresse',
  selectCountry: 'Wählen Sie Land aus',

  newUser: ' Neuer Benutzer',
  showDetails: 'Details anzeigen',
  Salutation: 'Geschlecht',
  subscriptionUpdated: 'Subscription updated.',

  // clients
  checkUnchecked: 'Prüfe nicht geprüfte Mandanten',
  checkSelected: 'Prüfe ausgewählte Mandanten',
  checkActive: 'Prüfe alle aktiven Mandanten',
  deactivateClient: 'Deaktivieren',
  documents: 'Dokumente/Identifikation',
  clientUpdate: 'Client aktualisiert',
  hideDetails: 'Details ausblenden',
  lastAccessTime: 'Letzter Zugriff',
  lastAccessLocation: 'Letzter Zugangsort',
  clientData: 'Mandantendaten',
  updateClientInfo: 'Mandanteninformationen aktualisieren',
  editClientData: 'Mandantendaten bearbeiten',
  editStammdaten:
    'Bearbeiten. Die Stammdaten werden bei der Erfassung automatisch gespeichert. Sie können die Eingabe jederzeit ändern.',
  activateClient: 'Wiederherstellen',
  exportAll: 'Export alle',
  exportSelected: 'Export Ausgewählte',
  filterInstructions:
    'Zusatzinfo zu den Buttons: Ein erneuter Klick deaktiviert den jeweiligen Filter. Filter können beliebig kombiniert werden, um die Ansicht gezielt einzugrenzen.',

  // Billing page
  billingManagement: 'Abrechnungsmanagement',
  signedAsAdmin: 'Als Administrator angemeldet',
  firstSentence:
    'Unser Abrechnungsmanagementportal ermöglicht Ihnen die bequeme Verwaltung Ihres Abonnementplans,',
  secondSentence: 'Ihrer Zahlungsmethoden und das Herunterladen Ihrer aktuellen Rechnungen.',
  backToApplication: 'Zurück zur Anwendung',
  currentTrialMode: 'Sie nutzen die Anwendung derzeit im Testmodus.',
  day: 'tag',
  remainingOr: 'verbleibend oder',
  point: 'punkt',
  Points: 'Punkte',
  pointsLeft: 'vebleibend',
  allSet: 'Alles ist bereit!',
  subscriptionIsActive: 'Ihr Abonnement ist aktiv und einsatzbereit.',
  plan: 'Abo',
  solo: 'Solo',
  team: 'Team',
  period: 'Zeitraum',
  month: 'Monat',
  year: 'Jahr',
  trial: 'Probe',
  thankForSub:
    'Vielen Dank, dass Sie sich für unseren Service entschieden haben. Geniessen Sie die Vorteile Ihres Abonnements.',
  manageSubscription: 'Abonnement verwalten',
  cancelSubscription: 'Abonnement kündigen',
  resumeSubscription: 'Kündigung zurücknehmen',
  confirmCancelSubscription:
    'Möchten Sie Ihr Abonnement wirklich kündigen? Ihr Guthaben und Zugang bleiben bis zum Ende des laufenden Abrechnungszeitraums erhalten.',
  subscriptionCancelScheduled:
    'Ihr Abonnement wird zum Ende des laufenden Abrechnungszeitraums gekündigt.',
  subscriptionReactivated: 'Die Kündigung wurde zurückgenommen. Ihr Abonnement läuft weiter.',
  subscriptionChangeError:
    'Die Abonnementänderung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
  subscriptionEndsOn: 'Ihr Abonnement endet am',
  subscriptionAccessUntilEnd: 'Bis dahin bleiben Guthaben und Zugang verfügbar.',
  monthly: 'monatlich',
  yearly: 'Jährlich',
  soloMonthFirst:
    'DS | KYC Solo – Der monatliche Solo-Tarif ist für einen Nutzer konzipiert und beinhaltet 10 Guthaben pro Monat.',
  soloMonthSecond: 'Benötigen Sie mehr Guthaben?',
  soloMonthThird: 'Sie können jederzeit zusätzliche Guthaben erwerben.',
  onlyOneUser: 'Nur 1 Benutzer',
  services: 'Dienstleistungen',
  dataSecurityServices: 'DATA Security Dienstleistungen',
  importClientsServices: 'Import von Mandantendaten',
  teamMonthFirst:
    'DS | KYC Team – Der monatliche Team-Plan ist für die Zusammenarbeit konzipiert, unterstützt mehrere Nutzer und beinhaltet 10 Guthaben pro Monat',
  teamMonthSecond: 'Benötigen Sie mehr Guthaben?',
  teamMonthThird: 'Sie können jederzeit zusätzliche Guthaben erwerben.',
  manyUsers: 'Viele Nutzer',
  soloYearFirst:
    'DS | KYC Solo – Jahresabo. Ideal für Einzelpersonen: Das Jahresabo Solo bietet Zugang für 1 Nutzer und 120 Credits pro Jahr.',
  soloYearSecond: 'Benötigen Sie mehr Credits?',
  soloYearThird: 'Sie können jederzeit zusätzliche Credits erwerben.',
  teamYearFirst:
    'Der speziell für Teams entwickelte Team-Jahresplan ermöglicht die Nutzung durch mehrere Benutzer',
  teamYearSecond: 'und beinhaltet 120 Credits pro Jahr.',
  teamYearThird: 'Zusätzliche Credits können bei Bedarf erworben werden.',
  additionalSeatNotice:
    'Enthält 1 Benutzer. Jeder weitere Teammitglied wird einmalig zusätzlich berechnet.',
  activeSubscriptionRequiredForTeamMembers:
    'Bitte schliessen Sie zuerst ein Abonnement ab, um weitere Teammitglieder hinzuzufügen.',
  subscriptionRequiredTitle: 'Abonnement erforderlich',
  trialAddUserRequiresSubscription:
    'Während der Probezeit können keine weiteren Benutzer angelegt werden. Schliessen Sie zuerst ein Abonnement ab, um Ihrem Team weitere Benutzer hinzuzufügen.',
  noPaymentMethodForTeamMember:
    'Keine Zahlungsmethode hinterlegt. Bitte fügen Sie eine Zahlungsmethode hinzu, um weitere Teammitglieder hinzuzufügen.',
  additionalSeatChargeFailed:
    'Die Zahlung für das zusätzliche Teammitglied ist fehlgeschlagen. Der Benutzer wurde nicht angelegt.',
  additionalSeatAuthenticationRequired:
    'Ihre Zahlungsmethode erfordert eine zusätzliche Bestätigung. Bitte aktualisieren Sie Ihre Zahlungsmethode und versuchen Sie es erneut.',
  additionalSeatPriceNotConfigured:
    'Die Abrechnung für zusätzliche Teammitglieder ist derzeit nicht konfiguriert. Bitte kontaktieren Sie den Support.',
  invalidPaymentMethod: 'Die ausgewählte Zahlungsmethode ist ungültig.',
  userNotCreated: 'Benutzer konnte nicht angelegt werden.',
  additionalSeatWarningBefore: 'Das Hinzufügen dieses Teammitglieds wird Ihnen einmalig',
  additionalSeatWarningAfter: 'berechnet.',
  choosePaymentMethod: 'Zahlungsmethode auswählen',
  noPaymentMethodsAddOne: 'Keine Zahlungsmethode hinterlegt.',
  expires: 'gültig bis',
  paymentMethod: 'Zahlungsmethode',
  noSavedPayment: 'Keine gespeicherten Zahlungsmethoden',
  addPaymentMethod: 'Zahlungsmethode hinzufügen',
  paymentInfo: 'Zahlungsinformationen',
  yourBillingAddress: 'Ihre Rechnungsadresse lautet: ',
  stateCountry: 'Bundesland',
  address: 'Anschrift',
  city: 'Stadt',
  zipPostalCode: 'Postleitzahl',
  vatNumber: 'Umsatzsteuer-Identifikationsnummer',
  invoices: 'Rechnungen',
  paid: 'bezahlt',
  updatePaymentInfo: 'Zahlungsinformationen aktualisieren',
  update: 'Aktualisieren',
  emailAfterCheck:
    'Sie erhalten nach der Überprüfung eine E-Mail. Das Ergebnis können Sie auch auf der Ansichtsseite einsehen.',
  amlCheckPersonsInfo:
    'zu prüfende Personen (inkl. wirtschaftlich Berechtigte aus dem Erhebungsbogen)',
  amlCheckCachedInfo: 'davon heute bereits geprüft – wird nicht erneut berechnet',
  notEnoughCredit: 'Nicht genügend Punkte.',
  representativeLegalEntity: 'Vertreter juristische Person',
  noLegalEntityAdded: 'Keine juristische Person hinzugefügt',
  date: 'Datum',
  service: 'Service',
  clientNumberIsMissing: 'Mandantennummer fehlt.',
  addClientNumberFirst:
    'Bitte fügen Sie zuerst eine Mandantennummer hinzu, um die Dokumente zu öffnen.',
  datasets: 'Datensätze',
  middleName: 'Zweiter Vorname',
  amlAddressType: 'Adresstyp',
  amlCaptureDate: 'Erfassungsdatum',
  amlDateFrom: 'Datum von',
  amlDateTo: 'Datum bis',
  amlDeceased: 'Verstorben',
  amlAddressLine1: 'Adresszeile 1',
  amlAddressLine2: 'Adresszeile 2',
  amlNationalities: 'Staatsangehörigkeiten',
  amlPepTier: 'PEP-Stufe',
  amlPublicationDate: 'Veröffentlichungsdatum',
  amlSanctionId: 'Sanktions-ID',
  amlAddresses: 'Adressen',
  amlAliases: 'Aliasse',
  amlLinkedBusinesses: 'Verknüpfte Unternehmen',
  amlContacts: 'Kontakte',
  amlDatesOfDeath: 'Sterbedaten',
  amlDisqualification: 'Disqualifikation',
  amlEvidence: 'Nachweise',
  amlGeneralRisk: 'Allgemeines Risiko',
  amlIdentifiers: 'Kennungen',
  amlLinkedPersons: 'Verknüpfte Personen',
  amlInsolvency: 'Insolvenz',
  amlProviderLinks: 'Anbieter-Links',
  amlPepByAssociation: 'PEP durch Verbindung',
  amlPepPositions: 'PEP-Positionen',
  amlPersonsOfInterest: 'Personen von Interesse',
  amlProfileImages: 'Profilbilder',
  amlRegulatoryEvents: 'Regulatorische Ereignisse',
  amlRiskEvents: 'Risikoereignisse',
  amlSanctions: 'Sanktionen',
  Relationship: 'Beziehung',
  firstSubscribe: 'Bitte abonnieren Sie zuerst, um eine Zahlungsmethode hinzuzufügen.',
  createPaymentCustomerError:
    'Fehler beim Erstellen des Stripe-Kunden. Bitte kontaktieren Sie den Support.',
  paymentCustomerEmailNotFound:
    'Zahlungskundenkonto konnte nicht erstellt werden: E-Mail-Adresse nicht gefunden.',
  requestProcessingError: 'Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten.',
  billingAddressUpdated: 'Rechnungsadresse erfolgreich aktualisiert.',
  billingAddressUpdateError: 'Beim Aktualisieren der Rechnungsadresse ist ein Fehler aufgetreten.',
  //stammdaten company
  stammdaten: 'Stammdaten',
  Mandant: 'Mandant',
  seit: 'seit',
  bis: 'bis',
  Anrede: 'Anrede',
  Angaben: ' Angaben zu Unternehmen / Vereinigung',
  Unternehmensname: 'Unternehmensname',
  Unternehmensform: 'Unternehmensform',
  Registertyp: 'Registertyp',
  Notiz: 'Notiz',
  Unternehmensdaten: 'Unternehmensdaten',
  Adressen: 'Adressen',
  Kommunikation: 'Kommunikation',
  Banken: 'Banken',
  Beziehungen: 'Beziehungen',
  DokumenteKanzlei: 'Dokumente für den Mandanten',
  datumHochladen: 'Datum des Hochladen',
  file: 'Datei',
  dokumenteMandantKanzlei: 'Dokumente vom Mandanten',
  additional: 'Zusätzlich',
  clientInfoDocumentNotFound: 'Kein Erhebungsbogen gefunden.',
  exportPDF: 'Export PDF',

  //stammdaten unterhnamen
  unternehmensgegenstand: 'Unternehmensgegenstand',
  ortFirmensitezes: 'Ort des Firmensitzes',
  landFirmensitzes: 'Land des Firmensitzes',
  gründungsdatum: 'Gründungsdatum',
  inLiquidation: 'in Liquidation',
  inAbwicklung: 'in Abwicklung',
  nationalesRecht: 'Nationales Recht',
  codeBeschreibung: 'Code / Beschreibung',
  ustNr: 'USt-IdNr.',
  eu_vat_id_number: 'EU VAT Id Number',
  bundesland: 'Bundesland',
  registergerichtsinformationen: 'Registergerichtsinformationen',
  registereintrag: 'Registereintrag',
  registergericht: 'Registergericht',
  registerNr: 'Register-Nr',
  firmennameLautRegistergericht: 'Firmenname laut Registergericht',

  //stammdaten address
  adresse: 'Adresse',
  remove: 'Entfernen',
  gültig: 'Gültig',
  von: 'von',
  adresszusatz: 'Adresszusatz',
  adressart: 'Adressart',
  street: 'Strassenadresse',
  postfachadresse: 'Postfachadresse',
  postcode: 'PLZ',
  place: 'Ort',
  versandzusatz: 'Versandzusatz',
  abweichenden: 'Abweichenden Zustelladressaten verwenden',
  abwAnrede: 'Abw. Anrede',
  abweichender: 'Abweichender',
  zustelladressat: 'Zustelladressat',
  bank: 'Bank',
  iban: 'IBAN',
  kontonummer: 'Kontonummer',
  kontoinhaber: 'Kontoinhaber',

  // Beziehung

  beziehung: 'Beziehung',
  hat: 'hat',
  ist: 'ist',
  angabenZu: 'Angaben zu',
  adressattype: 'Adressattype',
  natürlichePerson: 'Natürliche Person',
  unternehmenVereinigung: 'Unternehmen/Vereinigung',
  anrede: 'Anrede',
  titelGrad: 'Titel/Akad. Grad',
  vorname: 'Vorname',
  nachname: 'Nachname',
  nameSign: 'Name',
  geburtsdatum: 'Geburtsdatum',
  eTIN: 'eTIN',

  finanzamtsverbindung: 'Finanzamtsverbindung (Wohnsitz- bzw. Betriebsfinanzamt)',
  finanzamt: 'Finanzamt',
  steuernummer: 'Steuernummer',
  kommunikationAdresseübernehmen: 'Kommunikation und Adresse übernehmen',
  telephone: 'Telefon',
  plz: 'PLZ',
  updateUserDetails: 'Benutzerdaten aktualisieren',
  useThesePoints: 'Nutzen Sie diese Punkte, um auf Funktionen zuzugreifen.',

  // Stammdaten Communication
  telefonnummer: 'Telefonnummer',
  bemerkung: 'Bemerkung',
  standard: 'Standard',
  GL: 'GL',
  eMailAdresse: 'E-Mail Adresse',
  rechnung: 'Rechnung',
  URL: 'URL',
  sonstignummer: 'Sonstignummer',

  // Stammdaten Finanz
  nummerNamePlace: 'Nummer / Name / Place',

  // Stammdaten Share Modal
  teilen: 'Teilen',
  informationFürDenMandanten: 'Information für den Mandanten',
  chooseFiles: 'Dateien auswählen',
  chooseFile: 'Datei auswählen',
  setNameFirst: 'Bitte zuerst den Namen festlegen',
  chooseFilesToUpload: 'Dateien zum Hochladen auswählen',

  // Stammdaten Additional
  additionalField: 'Zusätzliches Feld',
  labelTypeOptions: 'Beschriftung, Typ und Optionen konfigurieren',
  fieldName: 'Feldname',
  chooseType: 'Typ wählen',
  value: 'wert',
  optionValue: 'Optionswert',
  options: 'Optionen',
  label: 'Bezeichnung',
  optionLabel: 'Optionsbezeichnung',
  addOption: 'Option hinzufügen',
  addField: 'Feld hinzufügen',
  editAdditionalForm: 'Zusatzformular bearbeiten',
  createAdditionalForm: 'Zusatzformular erstellen',
  formName: 'Formularname',
  include: 'Einbeziehen',
  textField: 'Textfeld',
  selectField: 'Auswahlfeld',
  checkboxField: 'Kontrollkästchen',
  uploadField: 'Upload-Feld',
  radioField: 'Frage/Antwort-Feld',
  radio: 'Frage/Antwort',
  answers: 'Antworten',
  noFieldsYet: 'Noch keine Felder vorhanden. Fügen Sie oben eines hinzu.',
  field: 'Feld',
  type: 'Typ',
  text: 'Text',
  select: 'Auswählen',
  checkbox: 'Kontrollkästchen',
  upload: 'Hochladen',
  addAtLeastOneOption: 'Fügen Sie mindestens eine Option hinzu.',
  updating: 'Wird aktualisiert…',
  saving: 'Wird gespeichert…',
  updateForm: 'Formular aktualisieren',
  saveForm: 'Formular speichern',
  formNameRequired: 'Formularname ist erforderlich.',
  addAtLeastOneField: 'Fügen Sie mindestens ein Feld hinzu.',
  everyFieldMustHaveName: 'Jedes Feld muss einen Namen haben.',
  fieldNeedsOption: 'Feld benötigt mindestens eine Option.',
  optionsNeedLabel: 'Optionen benötigen eine Bezeichnung.',
  updateFailed: 'Aktualisierung fehlgeschlagen',
  saveFailed: 'Speichern fehlgeschlagen',
  failedToLoadForm: 'Formular konnte nicht geladen werden',

  // Stammdaten Dynamic Form List
  formSchemas: 'Formularvorlagen',
  manageSearchReuseForms: 'Dynamische Formulare erstellen, verwalten und wiederverwenden',
  createCompanyForm: 'Unternehmensformular erstellen',
  createPersonForm: 'Personenformular erstellen',
  All: 'Alle',
  Company: 'Unternehmen',
  Person: 'Person',
  searchByNameOrField: 'Nach Name oder Feld suchen',
  sortByLastUpdateNewest: 'Sortieren nach letzter Aktualisierung (neueste)',
  sortByLastUpdateOldest: 'Sortieren nach letzter Aktualisierung (älteste)',
  sortByNameAZ: 'Sortieren nach Name (A–Z)',
  sortByNameZA: 'Sortieren nach Name (Z–A)',
  sortByFieldsCountDesc: 'Sortieren nach Feldanzahl (absteigend)',
  sortByFieldsCountAsc: 'Sortieren nach Feldanzahl (aufsteigend)',
  sortByCreatedNewest: 'Sortieren nach Erstelldatum (neueste)',
  sortByCreatedOldest: 'Sortieren nach Erstelldatum (älteste)',
  pageSize: 'Seitengrösse',
  loading: 'Wird geladen…',
  Name: 'Name',
  Fields: 'Felder',
  Updated: 'Aktualisiert',
  Actions: 'Aktionen',
  includeInStammdaten: 'Einbeziehen',
  Include: 'Einbeziehen',
  Exclude: 'Ausschliessen',
  close: 'Schliessen',
  Open: 'Öffnen',
  Delete: 'Löschen',
  noFormsFound: 'Keine Formulare gefunden',
  showing: 'Zeige',
  of: 'von',
  First: 'Erste',
  Prev: 'Zurück',
  Page: 'Seite',
  Next: 'Weiter',
  Last: 'Letzte',
  loadError: 'Ladefehler',
  updateNotSuccess: 'Aktualisierung nicht erfolgreich',
  finanzLabel: 'Es ist zwingend erforderlich, mindestens einen Finanzamtstyp auszuwählen:',
  selectTaxLabel: 'Bitte wählen Sie mindestens eine Art von Finanzamt aus:',
  includedInStammdaten: 'In Stammdaten enthalten',
  change: 'Ändern',

  // Stammdaten page
  kycStammdaten: 'KYC Stammdaten',
  naturlichePerson: 'Natürliche Person',

  // Stammdaten Person
  mandantNumber: 'Mandanten-Nr.',
  empfehlung: 'Empfehlung: Lassen Sie das Feld leer - DATEV ermittelt die Nummber automatisch',
  angabenNaturlichenPerson: ' Angaben zur Natürlichen Person',
  nameKurz: 'Name kurz',
  adelstitel: 'Adelstitel',
  namensvorsatz: 'Namensvorsatz',
  alternativerSuchname: 'Alternativer Suchname',
  persönlicheDaten: 'Persönliche Daten',
  geburtsname: 'Geburtsname',
  vollständigeVornamen: 'Vollständige Vornamen',
  geburtsort: 'Geburtsort',
  geburtsland: 'Geburtsland',
  staatsangehörigkeit: 'Staatsangehörigkeit',
  historie: 'Historie',
  hinzufügen: 'Hinzufügen',
  männlich: 'Männlich',
  weiblich: 'Weiblich',
  divers: 'Divers',
  familienstand: 'Familienstand',
  ledig: 'Ledig',
  verheiratet: 'Verheiratet',
  geschieden: 'Geschieden',
  verwitwet: 'Verwitwet',
  dauerndGetrenntLebend: 'Dauernd getrennt lebend',
  lebenspartnerschaftEingetragen: 'Lebenspartnerschaft eingetragen',
  lebenspartnerschaftAufgehoben: 'Lebenspartnerschaft aufgehoben',
  rentenversNr: 'Rentenvers.-Nr.',
  rentenversTräger: 'Rentenvers. Träger',
  sozialversNr: 'Sozialvers.-Nr.',
  sozialversicherungsnummer: 'Sozialversicherungsnummer',
  identifikationsnummer: 'Identifikationsnummer',
  legitimationsart: 'Legitimationsart',
  personalausweis: 'Personalausweis',
  personalData: 'Persönliche Daten',
  reisepass: 'Reisepass',
  führerschein: 'Führerschein',
  sonstigerAusweis: 'Sonstiger Ausweis',
  urkunde: 'Urkunde',
  persönlicheBekanntschaft: 'Persönliche Bekanntschaft',
  erkennungszeuge: 'Erkennungszeuge',
  besondereSachkunde: 'Besondere Sachkunde',
  elektronischerIdentitätsnachweis: 'Elektronischer Identitätsnachweis',
  qualifizierteElektronischeSignatur: 'Qualifizierte elektronische Signatur',
  elektronischesIdentifizierungssystem: 'Elektronisches Identifizierungssystem',
  kommentar: 'Kommentar',
  PEP: 'Politisch exponierte Person (PEP)',
  ausweisnummer: 'Ausweisnummer',
  gültigBis: 'Gültig bis',
  ausgestelltAm: 'Ausgestellt am',
  ausstellendeBehörde: 'Ausstellende Behörde',
  gwgIdentificationHint:
    '* Für eine vollständige Identifizierung gemäss GwG sind folgende Angaben erforderlich',

  // Stammdaten Company Required
  companyRequired: 'Pflichtfelder Unternehmen',
  personRequired: 'Pflichtfelder Natürliche Person',
  mandantSeit: 'Mandant seit',
  mandantBis: 'Mandant bis',
  gültigVon: 'Gültig seit',
  taxOffice: 'Finanzamtsverbindung (Wohnsitz-bzw. Betriebsfinanzamt)',
  communicationAndAddress: 'Kommunikation und Adresse übernehmen',

  stammdatenConfirm: 'Das Ausfüllen dieses Formulars ist abgeschlossen',
  fieldValidationTitle:
    'Alle mit einem roten Stern gekennzeichneten Felder müssen ausgefüllt werden!',

  // Settings
  teamOwner: 'Team-Administrator',
  teamName: 'Teamname',
  teamAdmin: 'Als Teamadministrator können Sie',
  shareCredits: 'Die Anerkennung sollte unter allen Teammitgliedern aufgeteilt werden.',
  manageBilling: 'Die Abrechnung über ein einziges Konto verwalten (nur der Administrator zahlt).',
  trackActivity: 'Aktivitäten aller Mitglieder und deren Unterschriften verfolgen',
  controlAccess: 'Zugriffsrechte und Rollen innerhalb des Teams kontrollieren',
  idealFormTeams:
    'Ideal für Teams, die eine zentrale Steuerung und eine einfache Guthabenverteilung benötigen.',
  serviceUsage: 'Servicenutzung',
  lastActivities: 'Letzte Aktivitäten',
  justNow: 'gerade eben',
  allTime: 'Gesamter Zeitraum',
  dsIdentityUsage: 'DS Identity',
  identityRequestDeleted: 'Identitätsanfrage gelöscht',
  dsSignUsage: 'DS Sign',
  transparenzregisterUsage: 'Transparenzregister',
  amlUsage: 'Handelsregister',
  kycCheckUsage: 'KYC Check',

  setClientName: 'Bitte geben Sie zuerst den Namen des Mandanten ein.',
  noResults: 'Keine Ergebnisse',

  trModalTitle: 'Transparenzregister',
  trSearchResults: 'Suchergebnisse',
  trFirmenname: 'Firmenname',
  trSitz: 'Sitz',
  trEkrn: 'EKRN',
  trClientName: 'Firmenname',
  trEmail: 'Transparenzregister Benutzername / (E-Mail)',
  trPassword: 'Transparenzregister Kennwort',
  trSearch: 'Suche',
  trSearching: 'Suche läuft…',
  trDocumentRequest: 'Dokument anfordern',
  trRequesting: 'Anfrage läuft…',
  trSearchFailed: 'Suche fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.',
  trDocumentRequestFailed: 'Dokument konnte nicht angefordert werden.',
  trCredentialsRequired: 'Bitte E-Mail und Passwort für das Transparenzregister eingeben.',
  trSearchRequiresFirmennameOrRegisternummer: 'Bitte Firmenname oder Registernummer angeben.',
  trRegisternummer: 'Registernummer',
  trDocumentVorhanden: 'TR-Auszug liegt bereits vor',
  trDocumentNichtErforderlich: 'TR-Auszug ist nicht erforderlich',
  trMarkStatusFailed: 'Status konnte nicht gespeichert werden.',
  trPostleitzahl: 'Postleitzahl',
  trPostleitzahlOptional: 'Optional',
  trFirmennameMinLength: 'Firmenname muss mindestens 2 Zeichen lang sein.',
  all: 'Alle',

  // Survey Form
  surveyForm: 'Erhebungsbogen - GwG für juristische Person Personengesellschaft',
  contractualPartner: 'Vertragspartner',
  identification: 'Identifizierung',
  identificationRequestFailed: 'Identifizierungsanfrage fehlgeschlagen.',
  establishingIdentity: 'Identitätsfeststellung des Vertragspartners',
  alreadyIdentified:
    'Wurde bereits früher identifiziert und die dabei erhobenen Daten wurden aufgezeichnet',
  newAssessment: 'Neufeststellung',
  legalForm: 'Rechtsform',
  registerNumber: 'Mandantennummer',
  addressOfRegisteredOffice: 'Anschrift des Sitzes oder der Hauptniederlassung',
  representativeBody: 'Vertretungsorgan oder der gesetzlichen Vertreter, natürliche Person',
  representativeNaturalPerson: 'Vertreter natürliche Person / Lebenspartner',
  authority: 'Ausstellende Behörde',
  idNumber: 'Ausweis-/Passnummer',
  nationality: 'Staatsangehörigkeit',
  birthPlace: 'Geburtsort',
  VNPhinzufügen: 'VNP hinzufügen',
  notice: 'Notiz',
  relatedCompanyBody: 'Vertretungsorgan oder der gesetzlichen Vertreter, juristische Person',
  identitVerificationContractualPartner: 'Identitätsüberprüfung des Vertragspartners',
  identityHasBeenVerified:
    'Die Identität wurde überprüft (Kopien/Unterlagen erstellt und liegen bei):',
  extractFromCommerical:
    'Auszug aus dem Handels- oder Genossenschaftsregister oder aus einem vergleichbaren amtlichen Register oder Verzeichnis',
  foundingDocuments: 'Gründungsdokumente oder gleichwertige beweiskräftige Dokumente',
  ownDocumented: 'Eigene dokumentierte Einsichtnahme in die Register- oder Verzeichnisdaten',
  simplifiedDueDiligence:
    'Bei vereinfachten Sorgfaltspflichten anhand von sonstigen Dokumenten, Daten oder Informationen, die von einer glaubwürdigen und unabhängigen Quelle stammen und für die Überprüfung geeignet sind',
  personActingContractualPartner: 'Für den Vertragspartner auftretende Person (sofern vorhanden)',
  identificationContractualPartner:
    'Identitätsfeststellung der für den Vertragspartner auftretenden Person',
  identityVerification: 'Identitätsüberprüfung der für den Vertragspartner auftretenden Person',
  idProof: 'Ausweis-/Passnummer',
  electronicIdProof:
    'Durch elektronischen Identitätsnachweis, qualifizierte elektronische Signatur, notifiziertes elektronisches Identifizierungssystem',
  otherProof:
    'Bei vereinfachten Sorgfaltspflichten anhand von sonstigen Dokumenten, Daten oder Informationen, die von einer glaubwürdigen und unabhängigen Quelle stammen und für die Überprüfung geeignet sind',
  identificationBeneficialOwners: 'Identifizierung von wirtschaftlich Berechtigten',
  legalEntitiesAndUnlistedCompanies: 'Juristische Personen und nicht börsennotierte Gesellschaften',
  shareHolder: 'Gesellschafter',
  identityVerificationThrough: 'Identitätsüberprüfung durch',
  beneficialOwner: 'Wirtschaftlich Berechtigter',
  noRegisteredBeneficialOwner: 'Kein wirtschaftlich Berechtigter eingetragen',
  noBeneficialOwners:
    ' Keine wirtschaftlich Berechtigten, da von keiner natürlichen Person unmittelbar oder mittelbar mehr als 25 % der Kapitalanteile gehalten, mehr als 25 % der Stimmrechte kontrolliert oder auf vergleichbare Weise Kontrolle ausgeübt wird',
  hasBeneficialOwners:
    'Es gibt wirtschaftlich Berechtigte, die als natürliche Personen unmittelbar oder mittelbar mehr als 25 % der Kapitalanteile halten, mehr als 25 % der Stimmrechte kontrollieren oder auf vergleichbare Weise Kontrolle ausüben',
  surveyFiles: 'Dokumente',
  surveyFormFinished: 'Bearbeitung abgeschlossen',
  legalyConstituted: 'Rechtsfähige Stiftungen und vergleichbare Rechtsgestaltungen',
  hasBeneficiialFoundations: 'Es gibt wirtschaftlich Berechtigten',

  naturalPersonRoleAdmin: 'Natürliche Person als Treugeber, Verwalter von Trusts oder Protektor',
  naturalPersonRoleManagementBoard: 'Natürliche Person Mitglied des Vorstandes',
  naturalPersonRoleAssetsDistributed: 'Natürliche Person, die als Begünstigte bestimmt worden ist',
  naturalPersonRoleBeneficiary:
    'Gruppe von natürlichen Personen, zu deren Gunsten das Vermögen verwaltet oder verteilt wird, da die natürliche Person, die Begünstigte des verwaltenden Vermögens werden soll, noch nicht bestimmt ist',
  naturalPersonRoleOther:
    'Natürliche Person, die auf sonstige Weise unmittelbar oder mittelbar beherrschenden Einfluss auf die Vermögensverwaltung oder Ertragsverteilung ausübt',

  beneficialOwnerOnTheBasisOfActing:
    'Wirtschaftlich Berechtigter aufgrund eines Handelns auf Veranlassung',
  transactionsCarriedOut: 'Werden Transaktionen auf Veranlassung eines anderen durchgeführt?',

  politicallyExposedPersons: 'Politisch exponierte Personen',
  highRiskCountries: 'Hochrisikoländer',
  informationOnTheBusinessRelationship: 'Angaben zur Geschäftsbeziehung',
  furtherInformation: 'Weitere Informationen',
  noOneConnected:
    'Weder der Vertragspartner noch der wirtschaftlich Berechtigte (soweit vorhanden) ist selbst eine politisch exponierte Person, ein Familienmitglied einer politisch exponierten Person oder eine einer politisch exponierten Person bekanntermassen nahestehende Person.',
  closeToPolitically:
    'Der Vertragspartner oder der wirtschaftlich Berechtigte (soweit vorhanden) ist selbst eine politisch exponierte Person, ein Familienmitglied einer politisch exponierten Person oder eine einer politisch exponierten Person bekanntermassen nahestehende Person.',
  preciseDesignation:
    'Genaue Bezeichnung der politisch exponierten Person und/oder Beziehung zu ihr',
  notEstablishedInHighRiskCountry:
    'Weder der Vertragspartner noch der wirtschaftlich Berechtigte (soweit vorhanden) ist in einem von der Europäischen Kommission nach Artikel 9 der Richtlinie (EU) 2015/849 ermittelten Drittstaat mit hohem Risiko niedergelassen.',
  establishedInHighRiskCountry:
    'Der Vertragspartner oder der wirtschaftlich Berechtigte (soweit vorhanden) ist in einem von der Europäischen Kommission nach Artikel 9 der Richtlinie (EU) 2015/849 ermittelten Drittstaat mit hohem Risiko niedergelassen.',
  thirdCountry: 'Drittstaat',
  purposeAndNatureClear:
    'Zweck und Art ergeben sich zweifelsfrei aus der Geschäftsbeziehung selbst',
  purposeAndNatureDescription: 'Zweck und Art der Geschäftsbeziehung',

  idCardPassport: 'Durch Ausweis/Pass',
  electronicIdentityProof:
    'Durch elektronischen Identitätsnachweis, qualifizierte elektronische Signatur, notifiziertes elektronisches Identifizierungssystem',
  birthCertificateUnder16:
    'Bei Person, die das 16. Lebensjahr noch nicht vollendet hat durch Geburtsurkunde in Verbindung mit der Überprüfung der Identität des gesetzlichen Vertreters',
  guardianshipCertificate:
    ' Bei Betreuten durch Bestellungsurkunde des Betreuers und Überprüfung der Identität des Betreuers',
  identityEstablishmentAndIdentityVerification:
    'Ba und Bb. Identitätsfeststellung und Identitätsüberprüfung',
  hasBeneficialOwners1: 'Es gibt wirtschaftlich Berechtigten',
  noBeneficialOwners1: 'Es gibt keine(n) wirtschaftlich Berechtigte(n)',
  authorizationVerifiedBy:
    'Berechtigung der für den Vertragspartner auftretende Person überprüft anhand von',

  documentTitle: 'Dokumenttitel',
  description: 'Beschreibung',
  emailSubject: 'E-Mail-Betreff',
  emailMessage: 'E-Mail-Nachricht',
  documentInformation: 'Dokumentinformationen',
  addAnotherRecipient: 'Einen weiteren Empfänger hinzufügen',
  viewOnly: 'Nur zur Ansicht',
  chooseCountry: 'Land auswählen',
  Register: 'Registrieren',
  forgotYourPassword: 'Passwort vergessen',
  logIn: 'Anmelden',
  pinCodeValidationLogin: 'PIN-Code-Verifizierung',
  sendCodeToMe: 'Code an mich senden',
  stammdatenSendCodeHint:
    'Um Ihre Identität zu überprüfen, senden wir Ihnen einen einmaligen Zugriffscode an Ihre E-Mail-Adresse. Klicken Sie unten auf die Schaltfläche, wenn Sie bereit sind.',
  verifyPinCode: 'Bestätigen',
  accessDocument: 'Auf Dokument zugreifen',
  excelFileExample: 'Excel Musterdatei',
  thisIsExampleExcel: 'Die Musterdatei können Sie hier herunterladen: ',
  downloadExample: 'Download Musterdatei',
  importList: 'Liste importieren',
  notTested: 'nicht geprüft',
  success: 'Erfolg',
  Success: 'Erfolg',
  warning: 'Warnung',
  danger: 'Gefahr',
  sortBy: 'Sortieren nach',
  sortByName: 'Sortieren nach Name',
  sortByClientNumber: 'Sortieren nach Mandantennummer',
  sortByCountry: 'Sortieren nach Land',
  sortByLastCheck: 'Sortieren nach letzter Prüfung',
  newest: 'neueste',
  oldest: 'älteste',
  check: 'Prüfen',
  view: 'Übersicht',
  viewDocuments: 'Dokumente',
  asc: 'aufsteigend',
  desc: 'absteigend',
  clientNumberExists: 'Mandantennummer existiert bereits',
  abacusConnectionCreated: 'Abakus-Verbindung hergestellt.',

  previewClient: 'Übersicht Mandant',
  clientInformation: 'Mandanteninformation',
  overviewOfClient: 'Übersicht über persönliche Daten und Identifikationsdaten',
  twoFactorAuth: '2-Faktor-Authentifizierung',
  deactivateSelected: 'Ausgewählte deaktivieren',
  deleteClients: 'Ausgewählte löschen',
  deletedClients: 'Gelöschte Mandanten',
  inactiveClient: 'Inaktive Mandanten',
  restoreSelected: 'Ausgewählte wiederherstellen',
  activateSelected: 'Ausgewählte aktivieren',
  preview: 'Vorschau',
  share:
    'Teilen. Hiermit können Sie Personen intern und extern einladen Stammdaten zu erfassen bzw. zu prüfen und Dokumente mit Ihnen auszutauschen.',
  formular: 'Formulare',
  sentToClient: 'Versendet an den Mandanten',
  pinCodeSent: 'Kauf abschliessen',
  confirmAction: 'Aktion bestätigen',
  pinCodeEmailSent: 'Der Bestätigungscode wurde Ihnen per E-Mail zugesandt',
  confirmationCode: 'Bestätigungscode',
  enterCode: 'Code eingeben',
  punkteWerdenVerrechnet: 'Punkte werden verrechnet.',
  'Existing DS|Identity request': 'Bestehende DS|Identity-Anfrage',
  'Remove existing DS|Identity request': 'Bestehende DS|Identity-Anfrage entfernen',
  'Remove DS|Identity request': 'DS|Identity-Anfrage entfernen',
  Status: 'Status',
  zefixCheck: 'Handelsregister Abfrage',
  zefixCheckResults: 'Zefix Suchergebnisse',
  zefixUid: 'UID',
  zefixChid: 'CHID',
  zefixLegalSeat: 'Sitz',
  zefixDeletionDate: 'Löschdatum',
  zefixStatusActive: 'Aktiv',
  zefixStatusCancelled: 'Gelöscht',
  zefixStatusBeingCancelled: 'In Liquidation',
  zefixSelectCompany: 'Auswählen',
  zefixAuditLog: 'Zefix Protokoll',
  zefixAuditLogTitle: 'Zefix Änderungsprotokoll',
  zefixAuditActionSearch: 'Suche',
  zefixAuditActionDetails: 'Details abgerufen',
  zefixAuditActionView: 'Anzeige',
  zefixAuditActionChange: 'Änderung erkannt',
  zefixAuditField: 'Feld',
  zefixAuditOldValue: 'Alter Wert',
  zefixAuditNewValue: 'Neuer Wert',
  zefixAuditNoLogs: 'Keine Protokolleinträge vorhanden.',
  zefixAuditUser: 'Benutzer',
  zefixAuditDate: 'Datum',
  zefixAuditAction: 'Aktion',
  uidCheckTitle: 'UID-Register Prüfung',
  uidInputLabel: 'UID-Nummer eingeben',
  uidSearch: 'Suchen',
  uidNewSearch: 'Neue Suche',
  uidNotFound: 'Keine UID-Einheit gefunden.',
  uidUid: 'UID',
  uidLegalName: 'Firma (offiziell)',
  uidLegalForm: 'Rechtsform',
  uidAddress: 'Adresse',
  uidStreet: 'Strasse',
  uidTown: 'Ort',
  uidCanton: 'Kanton',
  uidCountry: 'Land',
  uidLastCheck: 'Letzte Prüfung',
  uidRegInfo: 'UID-Register',
  uidregStatus: 'Status',
  uidregPublicStatus: 'Öffentlicher Status',
  uidCommercialReg: 'Handelsregister',
  uidCommercialStatus: 'HR Status',
  uidCommercialEntryStatus: 'Eintrag Status',
  uidCheckedAt: 'Abgerufen am',
  uidCheck: 'UID-Prüfung',
  uidAuditLog: 'UID Protokoll',
  clientNotes: 'Notiz',
  clientNotesPlaceholder: 'Notizen',
  noClientNotes: 'Keine Notizen vorhanden.',
  newNote: 'Neue Notiz',
  newNotePlaceholder: 'Notiz eingeben...',
  addNote: 'Hinzufügen',
  deleteNoteConfirm: 'Möchten Sie diese Notiz wirklich löschen?',
  uidAuditLogTitle: 'UID Änderungsprotokoll',
  uidAuditNoLogs: 'Keine Protokolleinträge vorhanden.',
  uidAuditAction_details: 'Details abgerufen',
  uidAuditAction_view: 'Anzeige',
  uidAuditAction_change: 'Änderung erkannt',
  uidLocalDataTitle: 'Systemdaten zum Vergleich',
  uidLocalDataHint:
    'Bitte geben Sie die bekannten Daten aus Ihrem System ein. Diese werden nach der UID-Abfrage verglichen.',
  uidLocalName: 'Firmenname',
  uidLocalNamePlaceholder: 'Firmenname eingeben',
  uidLocalLegalForm: 'Rechtsform',
  uidLocalCity: 'Ort',
  uidLocalCityPlaceholder: 'Ort eingeben',
  uidLocalCanton: 'Kanton',
  uidLocalStatus: 'Status',
  uidCompareTitle: 'Datenvergleich',
  uidCompareAllMatch: '✓ Alle geprüften Felder stimmen mit dem UID-Register überein.',
  uidCompareSomeMismatch: '⚠ Abweichungen festgestellt – bitte den Vergleich prüfen.',
  uidCompareField: 'Feld',
  uidCompareLocal: 'System',
  uidCompareUid: 'UID-Register',
  uidRegDetails: 'UID-Register Daten',
  betriebsfinanzamt: 'Betriebsfinanzamt',
  umsatzsteuerfinanzamt: 'Umsatzsteuerfinanzamt',
  lohnsteuerfinanzamt: 'Lohnsteuerfinanzamt',

  Afghanistan: 'Afghanistan',
  ÅlandIslands: 'Åland-Inseln',
  Albania: 'Albanien',
  Algeria: 'Algerien',
  AmericanSamoa: 'Amerikanisch-Samoa',
  Andorra: 'Andorra',
  Angola: 'Angola',
  Anguilla: 'Anguilla',
  Antarctica: 'Antarktis',
  AntiguaandBarbuda: 'Antigua und Barbuda',
  Argentina: 'Argentinien',
  Armenia: 'Armenien',
  Aruba: 'Aruba',
  Australia: 'Australien',
  Austria: 'Österreich',
  Azerbaijan: 'Aserbaidschan',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesch',
  Barbados: 'Barbados',
  Belarus: 'Belarus',
  Belgium: 'Belgien',
  Belize: 'Belize',
  Benin: 'Benin',
  Bermuda: 'Bermuda',
  Bhutan: 'Bhutan',
  BosniaandHerzegovina: 'Bosnien und Herzegowina',
  Botswana: 'Botswana',
  BouvetIsland: 'Bouvetinsel',
  Brazil: 'Brasilien',
  BritishIndianOceanTerritory: 'Britisches Territorium im Indischen Ozean',
  BruneiDarussalam: 'Brunei Darussalam',
  Bulgaria: 'Bulgarien',
  BurkinaFaso: 'Burkina Faso',
  Burundi: 'Burundi',
  CaboVerde: 'Cabo Verde',
  Cambodia: 'Kambodscha',
  Cameroon: 'Kamerun',
  Canada: 'Kanada',
  CaymanIslands: 'Kaimaninseln',
  CentralAfricanRepublic: 'Zentralafrikanische Republik',
  Chad: 'Tschad',
  Chile: 'Chile',
  China: 'China',
  ChristmasIsland: 'Weihnachtsinsel',
  Colombia: 'Kolumbien',
  Comoros: 'Komoren',
  Congo: 'Kongo',
  CookIslands: 'Cookinseln',
  CostaRica: 'Costa Rica',
  Croatia: 'Kroatien',
  Cuba: 'Kuba',
  Curaçao: 'Curaçao',
  Cyprus: 'Zypern',
  Czechia: 'Tschechien',
  Denmark: 'Dänemark',
  Djibouti: 'Dschibuti',
  Dominica: 'Dominica',
  DominicanRepublic: 'Dominikanische Republik',
  Ecuador: 'Ecuador',
  Egypt: 'Ägypten',
  ElSalvador: 'El Salvador',
  EquatorialGuinea: 'Äquatorialguinea',
  Eritrea: 'Eritrea',
  Estonia: 'Estland',
  Eswatini: 'Eswatini',
  Ethiopia: 'Äthiopien',
  FaroeIslands: 'Färöer-Inseln',
  Fiji: 'Fidschi',
  Finland: 'Finnland',
  France: 'Frankreich',
  FrenchGuiana: 'Französisch-Guayana',
  FrenchPolynesia: 'Französisch-Polynesien',
  FrenchSouthernTerritories: 'Französische Süd- und Antarktisgebiete',
  Gabon: 'Gabun',
  Gambia: 'Gambia',
  Georgia: 'Georgien',
  Germany: 'Deutschland',
  Ghana: 'Ghana',
  Gibraltar: 'Gibraltar',
  Greece: 'Griechenland',
  Greenland: 'Grönland',
  Grenada: 'Grenada',
  Guadeloupe: 'Guadeloupe',
  Guam: 'Guam',
  Guatemala: 'Guatemala',
  Guernsey: 'Guernsey',
  Guinea: 'Guinea',
  Guyana: 'Guyana',
  Haiti: 'Haiti',
  HeardIslandandMcDonaldIslands: 'Heard und McDonaldinseln',
  HolySee: 'Heiliger Stuhl',
  Honduras: 'Honduras',
  HongKong: 'Hongkong',
  Hungary: 'Ungarn',
  Iceland: 'Island',
  India: 'Indien',
  Indonesia: 'Indonesien',
  Iraq: 'Irak',
  Ireland: 'Ireland',
  IsleofMan: 'Isle of Man',
  Israel: 'Israel',
  Italy: 'Italien',
  Jamaica: 'Jamaika',
  Japan: 'Japan',
  Jersey: 'Jersey',
  Jordan: 'Jordanien',
  Kazakhstan: 'Kasachstan',
  Kenya: 'Kenia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kirgisistan',
  Latvia: 'Lettland',
  Lebanon: 'Libanon',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libyen',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Litauen',
  Luxembourg: 'Luxemburg',
  Macao: 'Macao',
  Madagascar: 'Madagaskar',
  Malawi: 'Malawi',
  Malaysia: 'Malaysia',
  Maldives: 'Malediven',
  Mali: 'Mali',
  Malta: 'Malta',
  MarshallIslands: 'Marshallinseln',
  Martinique: 'Martinique',
  Mauritania: 'Mauretanien',
  Mauritius: 'Mauritius',
  Mayotte: 'Mayotte',
  Mexico: 'Mexiko',
  Monaco: 'Monaco',
  Mongolia: 'Mongolei',
  Montenegro: 'Montenegro',
  Montserrat: 'Montserrat',
  Morocco: 'Marokko',
  Mozambique: 'Mosambik',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Niederlande',
  NewCaledonia: 'Neukaledonien',
  NewZealand: 'Neuseeland',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  Niue: 'Niue',
  NorfolkIsland: 'Norfolkinsel',
  NorthMacedonia: 'Nordmazedonien',
  NorthernMarianaIslands: 'Nördliche Marianen',
  Norway: 'Norwegen',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Panama: 'Panama',
  PapuaNewGuinea: 'Papua-Neuguinea',
  Paraguay: 'Paraguay',
  Peru: 'Peru',
  Philippines: 'Philippinen',
  Pitcairn: 'Pitcairninseln',
  Poland: 'Polen',
  Portugal: 'Portugal',
  PuertoRico: 'Puerto Rico',
  Qatar: 'Katar',
  Romania: 'Rumänien',
  RussianFederation: 'Russland',
  Rwanda: 'Ruanda',
  Réunion: 'Réunion',
  SaintBarthélemy: 'Saint-Barthélemy',
  SaintLucia: 'St. Lucia',
  SaintPierreandMiquelon: 'Saint-Pierre und Miquelon',
  SaintVincentandtheGrenadines: 'St. Vincent und die Grenadinen',
  Samoa: 'Samoa',
  SanMarino: 'San Marino',
  SaoTomeandPrincipe: 'São Tomé und Príncipe',
  SaudiArabia: 'Saudi-Arabien',
  Senegal: 'Senegal',
  Serbia: 'Serbien',
  Seychelles: 'Seychellen',
  SierraLeone: 'Sierra Leone',
  Singapore: 'Singapur',
  Slovakia: 'Slowakei',
  Slovenia: 'Slowenien',
  SolomonIslands: 'Salomonen',
  Somalia: 'Somalia',
  SouthAfrica: 'Südafrika',
  SouthGeorgiaandtheSouthSandwichIslands: 'Südgeorgien und die Südlichen Sandwichinseln',
  SouthSudan: 'Südsudan',
  Spain: 'Spanien',
  SriLanka: 'Sri Lanka',
  Sudan: 'Sudan',
  Suriname: 'Suriname',
  SvalbardandJanMayen: 'Svalbard und Jan Mayen',
  Sweden: 'Schweden',
  Switzerland: 'Schweiz',
  SyrianArabRepublic: 'Syrien',
  Tajikistan: 'Tadschikistan',
  Thailand: 'Thailand',
  Togo: 'Togo',
  Tokelau: 'Tokelau',
  Tonga: 'Tonga',
  TrinidadandTobago: 'Trinidad und Tobago',
  Tunisia: 'Tunesien',
  Turkey: 'Türkei',
  Turkmenistan: 'Turkmenistan',
  TurksandCaicosIslands: 'Turks- und Caicosinseln',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ukraine',
  UnitedArabEmirates: 'Vereinigte Arabische Emirate',
  UnitedKingdomofGreatBritainandNorthernIreland: 'Vereinigtes Königreich',
  UnitedStatesofAmerica: 'Vereinigte Staaten',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Usbekistan',
  Vanuatu: 'Vanuatu',
  VietNam: 'Vietnam',
  WesternSahara: 'Westsahara',
  Yemen: 'Jemen',
  Zambia: 'Sambia',
  Zimbabwe: 'Simbabwe',

  signingOrderOff:
    'Signatur-Reihenfolge ist ausgeschaltet. Alle Empfänger können parallel unterzeichnen. Felder zur Festlegung der Reihenfolge sind deaktiviert.',
  signingOrderOn:
    'Signatur-Reihenfolge ist eingeschaltet. Alle Empfänger müssen in der vorgegebenen Reihenfolge unterzeichnen. Einstellung über die Felder zur Festlegung der Reihenfolge.',
  disableOrder: 'Signatur-Reihenfolge ausschalten',
  enableOrder: 'Signatur-Reihenfolge einschalten',
  signatureStandard: 'Signatur Standard',
  qesPrice: 'Preis',
  qesFirstUseSurchargeNote:
    'Inklusive einmaliger Identifikationsgebühr für die erste QES dieses Benutzers.',
  qesFirstUsePending:
    'Für diesen Benutzer wird gerade eine erste QES verarbeitet. Bitte versuchen Sie es in wenigen Minuten erneut.',
  qesPriceLoading: 'Preis wird geladen…',
  qesPriceUnavailable:
    'Der QES-Preis konnte nicht ermittelt werden. Bitte versuchen Sie es erneut.',
  recipients: 'Empfänger',
  role: 'Rolle',
  sequence: 'Reihenfolge',
  unnamed: 'Unbenannt',
  needsToSign: 'Muss unterzeichnen',
  finished: 'fertig',
  needs_to_sign: 'Muss unterzeichnen',
  to_sign: 'Muss unterzeichnen',
  pending: 'Ausstehend',
  requestCreatedBy: 'Anfrage erstellt von',
  documentName: 'Dokument',
  uploadedAt: 'Hochgeladen am',
  uploadedBy: 'Hochgeladen von',
  order: 'Reihenfolge',
  sendLink: 'Link zum vergeben des passworts senden',
  dsSignCancel: 'DS|Sign stornieren',
  dsSignTeamNotAvailable:
    'DS|Sign Team ist nicht verfügbar. Bitte wenden Sie sich an den Administrator, um ein Team zu erstellen.',
  dsSignDelete: 'Dokument löschen Vorschau',
  previewUser: 'Benutzerübersicht',
  signed: 'Unterzeichnet',
  notSigned: 'Nicht unterzeichnet',
  userInformation: 'Benutzerinformation',
  overviewOfUser: 'Übersicht Benutzerprofil und Zugangsdaten',
  editUser: 'Benutzer bearbeiten',
  back: 'Zurück',
  unsigned: 'Nicht unterzeichnet',
  deleteDocument: 'Dokument löschen',
  protocol: 'Protokoll',
  beneficialOwnerAddedSuccessfully: 'Erfolg',
  representativeAddedSuccessfully: 'Erfolg',
  inactiveUsers: 'Inaktive Benutzer',
  recipientsSequenceNumber: 'Zwei oder mehr Empfänger haben die gleiche Sequenznummer.',
  emailRequired: 'Eine E-Mail-Adresse ist erforderlich.',
  nameRequired: 'Name erforderlich',
  emailInvalid: 'Die E-Mail-Adresse ist ungültig.',
  recipient: 'Empfänger',
  requestCreated: 'Anfrage erstellt',
  documentSent: 'Dokument erfolgreich an DS|Sign gesendet.',
  since: 'seit',
  until: 'bis',
  kycDocumentNotFound: 'Kein Dokument der KYC-Prüfung gefunden',
  addressLine1: 'Adresszeile',
  addressLine2: 'Adresszeile 2',
  noSubscriptionOrCredits: 'Kein Abonnement oder nicht ausreichend Guthaben',
  sortByLastName: 'Sortieren nach Nachname',
  sortByFirstName: 'Sortieren nach Vorname',
  sortByEmail: 'Sortieren nach E-Mail',

  deleteCompany: 'Firma löschen',
  resetData: 'Daten zurücksetzen',
  resetDataWarning:
    'Alle Mandantendaten, zusätzliche Benutzer und Protokolle werden unwiderruflich gelöscht. Die Firma und Ihr Benutzerkonto bleiben erhalten.',
  resetDataSuccess: 'Daten wurden erfolgreich zurückgesetzt.',

  saveRecoveryCode: 'Bewahren Sie Ihre Wiederherstellungscodes an einem sicheren Ort auf!',
  ifLoseAuthDevice:
    'Mit diesen Codes können Sie auf Ihr Konto zugreifen, wenn Sie Ihr Authentifizierungsgerät verlieren.',
  copyCodes: 'Codes kopieren',
  downloadCodes: 'Codes herunterladen',
  savedCodes: 'Ich habe die Codes gespeichert',
  serviceUsageHistory: 'Nutzungsverlauf',
  serviceUsageHistoryDescription: 'Beschreibung Nutzungsverlauf',
  noUsageHistory: 'Kein Nutzungsverlauf',
  noAdditionalSchemas: 'Keine Dokumente',
  notes: 'Notizen',
  requiredFileParams: 'clientId, Firmenname, Typ und Dateiname sind erforderlich',

  // Company Create Info
  registrationInfoTitle: 'Informationen zur Registrierung',
  registrationInfoIntro: 'Nach der Registrierung erhalten Sie zwei separate E-Mails:',
  registrationInfoKyc:
    'DS|KYC – Zugang zur KYC-Verwaltungsplattform für die Identitätsprüfung und Compliance.',
  registrationInfoSign:
    'DS|Sign – Zugang zum externen System für die digitale Dokumentenunterzeichnung, das direkt aus DS|KYC genutzt werden kann.',
  registrationInfoApproval:
    'Beide Konten müssen separat bestätigt werden, bevor Sie sich anmelden können.',

  // Email Branding
  emailBranding: 'E-Mail-Branding',
  senderEmailName: 'Absendername',
  senderEmailAddress: 'Absender-E-Mail-Adresse',
  emailHeader: 'E-Mail-Kopfzeile',
  emailSignature: 'E-Mail-Signatur',
  logo: 'Logo',
  emailAttachment: 'E-Mail-Anhang',
  emailAttachmentName: 'Anhangsname',
  uploadLogo: 'Logo hochladen',
  uploadAttachment: 'Anhang hochladen',
  emailBrandingUpdated: 'E-Mail-Branding erfolgreich aktualisiert.',
  emailBrandingError: 'Fehler beim Aktualisieren des E-Mail-Brandings.',
  fileLoaded: 'Datei geladen',

  // Abacus
  abacusIntegration: 'Abacus Integration',
  abacusConnectOpenID: 'Mit Abacus verbinden',
  abacusConnectDescription:
    'Verbinden Sie Ihr Konto mit Abacus über OpenID Connect, um Mandanten zu synchronisieren.',
  abacusServerUrl: 'Abacus Server-URL',
  abacusClientId: 'Client-ID',
  abacusClientSecret: 'Client-Secret',
  abacusServerUrlPlaceholder: 'https://entity-api.abacus.ch',
  abacusClientIdPlaceholder: 'z.B. 452fcd1d-6072-0c75-b9f3-7d391e46ab0e',
  abacusClientSecretPlaceholder: 'Client-Secret eingeben',
  abacusFieldsRequired: 'Bitte Server-URL und Client-ID eingeben.',
  abacusCredentialsRequired: 'Bitte Server-URL, Client-ID und Client-Secret eingeben.',
  abacusClientCredentials: 'Client Credentials',
  abacusOpenIdConnect: 'OpenID Connect',
  abacusConnectionSetup: 'Verbindung einrichten',
  abacusCredentialsDescription:
    'Geben Sie Ihre Abacus-Zugangsdaten ein, um eine Verbindung herzustellen.',
  abacusSaveConnection: 'Verbindung speichern',
  abacusConnectionFailed: 'Verbindung zum Abacus-Server fehlgeschlagen.',
  abacusImportClients: 'Mandanten importieren',
  abacusImportDescription:
    'Importieren Sie Mandanten aus Ihrer Abacus-Instanz. Bestehende Mandanten werden aktualisiert.',
  abacusMandantId: 'Mandanten-ID',
  abacusMandantIdPlaceholder: 'z.B. 7777',
  abacusMandantIdRequired: 'Bitte geben Sie eine Mandanten-ID ein.',
  abacusImporting: 'Wird importiert...',
  abacusImportResult: 'Ergebnis',
  abacusCreated: 'erstellt',
  abacusUpdated: 'aktualisiert',
  abacusImportFailed: 'Import der Mandanten fehlgeschlagen.',
  abacusTokenActive: 'Verbindung aktiv',
  abacusTokenExpiresAt: 'Token läuft ab am',
  abacusTokenExpired: 'Token ist abgelaufen. Bitte stellen Sie eine neue Verbindung her.',
  abacusTokenDuration: 'Der Token ist {minutes} Minuten gültig.',
  abacusDisconnect: 'Verbindung trennen',
  abacusDisconnectFailed: 'Trennen der Verbindung fehlgeschlagen.',
  abacusReconnect: 'Erneut verbinden',
  abacusReconnectFailed: 'Erneute Verbindung fehlgeschlagen.',

  // Bexio
  bexioIntegration: 'Bexio Integration',
  bexioCredentialsSetup: 'Zugangsdaten einrichten',
  bexioCredentialsDescription:
    'Geben Sie Ihre Bexio API-Zugangsdaten ein. Diese werden verschlüsselt gespeichert.',
  bexioClientId: 'Client-ID',
  bexioClientSecret: 'Client-Secret',
  bexioClientIdPlaceholder: 'z.B. abc123-...',
  bexioClientSecretPlaceholder: 'Client-Secret eingeben',
  bexioCredentialsRequired: 'Bitte Client-ID und Client-Secret eingeben.',
  bexioSaveCredentials: 'Zugangsdaten speichern',
  bexioSaveFailed: 'Zugangsdaten konnten nicht gespeichert werden.',
  bexioConnectTitle: 'Mit Bexio verbinden',
  bexioConnectDescription:
    'Klicken Sie auf die Schaltfläche, um sich bei Bexio anzumelden und die Verbindung zu autorisieren.',
  bexioConnectButton: 'Mit Bexio verbinden',
  bexioConnecting: 'Verbindung mit Bexio wird hergestellt...',
  bexioConnected: 'Erfolgreich mit Bexio verbunden.',
  bexioConnectionFailed: 'Verbindung mit Bexio fehlgeschlagen',
  bexioTokenActive: 'Verbindung aktiv',
  bexioTokenExpiresAt: 'Token läuft ab am',
  bexioTokenExpired: 'Token ist abgelaufen. Bitte Token erneuern oder neu verbinden.',
  bexioRefreshToken: 'Token erneuern',
  bexioRefreshFailed: 'Token-Erneuerung fehlgeschlagen.',
  bexioDisconnect: 'Verbindung trennen',
  bexioDisconnectFailed: 'Trennen der Verbindung fehlgeschlagen.',
  bexioImportContacts: 'Kontakte importieren',
  bexioImportDescription:
    'Laden Sie Kontakte aus Ihrem Bexio-Konto und wählen Sie aus, welche als Mandanten importiert werden sollen.',
  bexioLoadContacts: 'Kontakte laden',
  bexioLoadingContacts: 'Wird geladen...',
  bexioLoadContactsFailed: 'Kontakte konnten nicht geladen werden.',
  bexioNoContacts: 'Keine Kontakte gefunden.',
  bexioImportSelected: 'Ausgewählte importieren',
  bexioImporting: 'Wird importiert...',
  bexioImportResult: 'Ergebnis',
  bexioCreated: 'erstellt',
  bexioUpdated: 'aktualisiert',
  bexioImportFailed: 'Import der Kontakte fehlgeschlagen.',
  bexioColType: 'Typ',
  bexioColName: 'Name',
  bexioColFirstName: 'Vorname',
  bexioColAddress: 'Adresse',
  bexioColBirthday: 'Geburtsdatum',
  bexioPerson: 'Person',
  bexioCompany: 'Unternehmen',
  bexioTabOAuth: 'OAuth (Client ID & Secret)',
  bexioTabPat: 'Personal Access Token',
  bexioPatSetup: 'Personal Access Token einrichten',
  bexioPatDescription:
    'Erstellen Sie ein Personal Access Token auf developer.bexio.com und fügen Sie es hier ein.',
  bexioPatLabel: 'Personal Access Token',
  bexioPatPlaceholder: 'Token eingeben',
  bexioPatSave: 'Token speichern',
  bexioPatRequired: 'Bitte einen Token eingeben.',
  bexioPatSaveFailed: 'Token konnte nicht gespeichert werden.',
  bexioPatConnected: 'Verbunden über Personal Access Token.',

  // API Error Messages
  subdomainMissing: 'Subdomain fehlt oder ist ungültig.',
  accessTokenMissing: 'Zugriffstoken fehlt oder ist ungültig.',
  sessionExpired: 'Sitzung abgelaufen oder ungültig. Bitte erneut anmelden.',
  invalidOrigin: 'Zugriff verweigert: Ungültiger Ursprung.',
  routeNotFound: 'Route nicht gefunden',
  downloadPdf: 'PDF herunterladen',

  updatedSubscription: 'Abonnement aktualisiert',
  canceled: 'Storniert',
  dsSignRequestsByStatus: 'DS|Sign Anfragen nach Status',
  dsSignStatusInProcess: 'In Bearbeitung',
  dsSignTrStatusSucceeded: 'Abgeschlossen',
  dsSignTrStatusCanceled: 'Storniert',
  dsSignTeamCreated: 'Team erstellt. Sie können Dokumente einfügen.',
  dsSignTeamNotCreated:
    'DS|Sign-Team konnte nicht erstellt werden. Möglicherweise existiert bereits ein Konto mit dieser E-Mail-Adresse; in diesem Fall kann mit diesem Konto kein DS|Sign-Team erstellt werden. Melden Sie ein Problem.',
  createDsSignTeam: 'DS Sign Team erstellen',
  createDsSignTeamDescription:
    'Mit diesem Klick wird ein Konto für Ihr Unternehmen beim DS|Sign-Dienst angelegt. Sie erhalten eine E-Mail zur Bestätigung des Kontos. Anschliessend können Sie und Ihre Teammitglieder digitale Signaturanfragen erstellen.',
  createTeam: 'Team erstellen',
  dsSignIntegration: 'DS|Sign',
  userAddedForDsSign: 'Benutzer zu DS Sign hinzugefügt',
  dsSignTeamNotDeleted: 'DS|Sign-Team wurde nicht gelöscht.',
  dsSignTeamDeleted: 'DS|Sign-Team wurde gelöscht.',
  dsSignTeamNotDeletedInLocal:
    'DS|Sign-Team wurde nicht vollständig gelöscht. Bitte melden Sie ein Problem.',
  deleteDsSignTeam: 'DS Sign Team löschen',
  deleteDsSignTeamDescription:
    'Mit diesem Klick wird das DS|Sign-Team-Konto dauerhaft gelöscht. Alle anderen DS|Sign-Benutzer Ihres Teams werden ebenfalls entfernt und alle laufenden Signaturanfragen werden abgebrochen.',
  deleteTeam: 'Team löschen',

  failedUpdateBranding: 'Fehler beim Aktualisieren des E‑Mail‑Brandings',
  history: 'Verlaufsdaten',
  noHistory: 'Keine Geschichte.',

  // AML Order Modal
  handelsregisterOrder: 'Handelsregister – Bestellung',
  Court: 'Gericht',
  selectCourt: 'Gericht auswählen...',
  registerNumberAml: 'Register-Nummer',
  registerType: 'Register-Typ',
  selectRegisterType: 'Register-Typ auswählen...',
  failedToLoadOptions: 'Optionen konnten nicht geladen werden.',
  clientIdMissing: 'ClientId ist nicht gesetzt.',
  courtIsRegistered: 'Gericht ist erforderlich.',
  registerTypeIsRequired: 'Register-Typ ist erforderlich.',
  registerNumberInvalid: 'Register-Nummer muss numerisch sein.',
  failedToPlaceOrder: 'Dokumente konnten nicht bestellt werden.',
  failedToCommunicateServer: 'Verbindung zum Server fehlgeschlagen.',
  ordering: 'Wird bestellt…',
  enableDemo: 'Demo-Modus aktivieren',
  piiEncryption: 'PII-Verschlüsselung',
  enablePiiEncryption: 'PII-Verschlüsselung aktivieren',
  piiEncryptionPermanent: 'Aktiviert (kann nicht deaktiviert werden)',
  serviceDisabledByPiiEncryption:
    'Dieser Dienst ist bei aktivierter PII-Verschlüsselung nicht verfügbar.',
  encryptedSearchUnavailableClients:
    'Bei aktivierter PII-Verschlüsselung ist die Suche nach Name, E-Mail und Land nicht verfügbar. Die Suche nach der Client-Nummer funktioniert weiterhin.',
  disableDemo: 'Demo-Modus deaktivieren',
  subdomainHeader: 'Geben Sie Ihren Unternehmensname ein',

  accountNotExists: 'Es existiert kein Konto mit diesem Namen. Bitte registrieren Sie sich zuerst.',

  // Service overview
  serviceOverview: 'Leistungsübersicht',
  serviceOverviewDescription: 'Übersicht über alle verfügbaren Dienste und deren Punktekosten.',
  pointCost: 'Kosten (Punkte)',
  serviceFree: 'Kostenlos',
  variabel: 'Variabel',
  free: 'Kostenlos',

  // Landing page
  heroTitle: 'Compliance leicht gemacht',
  heroSubtitle:
    'Digitale Identitätsprüfung, KYC-Compliance und sichere Dokumentenunterzeichnung – alles auf einer Plattform.',
  howItWorks: 'So funktioniert es',
  step1Title: 'Registrieren',
  step1Desc: 'Erstellen Sie Ihr Firmenkonto in wenigen Minuten.',
  step2Title: 'Punkte erwerben',
  step2Desc: 'Erwerben Sie Guthaben für die gewünschten Dienste.',
  step3Title: 'Dienste nutzen',
  step3Desc: 'Nutzen Sie KYC-Prüfungen, Videoidentifikation, digitale Signatur und mehr.',

  // Transparenzregister request statuses
  transparenzRequestsByStatus: 'Transparenzregister – Anfragen nach Status',
  trStatusQueued: 'In Warteschlange',
  trStatusProcessing: 'In Bearbeitung',
  trStatusInProcess: 'In Bearbeitung',
  trStatusSucceeded: 'Erfolgreich',
  trStatusFailed: 'Fehlgeschlagen',
  trStatusUnknown: 'Unbekannt',

  // DS Identity request statuses
  identityRequestsByStatus: 'DS Identity – Anfragen nach Status',
  identityStatusPending: 'Ausstehend',
  identityStatusSuccess: 'Erfolgreich',
  identityStatusFailed: 'Fehlgeschlagen',
  identityStatusExpired: 'Abgelaufen',
  identityStatusReviewPending: 'In Überprüfung',
  identityStatusCreated: 'Erstellt',
  identityStatusUnknown: 'Unbekannt',
  identityStatusAssigned: 'Zugewiesen',
  identityStatusInProcess: 'In Bearbeitung',
  identityStatusFinished: 'Abgeschlossen',
  // AML request statuses
  amlRequestsByStatus: 'Handelsregister (AML) – Anfragen nach Status',
  amlStatusPending: 'Ausstehend',
  amlStatusDone: 'Abgeschlossen',
  amlStatusProcessing: 'In Bearbeitung',
  amlStatusFailed: 'Fehlgeschlagen',
  amlChecksSaved: 'AML-Prüfungen',
  amlChecksDeleted: 'AML-Prüfungen gelöscht',

  // Swiss Transparency Register (Transparenzregister CH)
  transparenzChTitle: 'Transparenzregister CH',
  transparenzChCompanyUid: 'Firmen-UID',
  transparenzChFiUid: 'FI-UID (Finanzintermediär)',
  transparenzChFiPid: 'FI-Benutzer-ID',
  transparenzChCheck: 'Prüfen',
  transparenzChNewCheck: 'Neue Prüfung',
  transparenzChAllFieldsRequired: 'Alle Felder sind erforderlich.',
  transparenzChRequestFailed: 'Anfrage an das Schweizer Transparenzregister fehlgeschlagen.',
  transparenzChNoResponse:
    'Die Anfrage wurde gespeichert, aber es wurden keine Daten zurückgegeben.',
  transparenzChCheckedAt: 'Geprüft am',
  transparenzChNoRecords: 'Keine Einträge zu wirtschaftlich Berechtigten gefunden.',
  transparenzChUnmatchedUid: 'Nicht gefundene UID',
  transparenzChRecordsFound: 'Gefundene Einträge',
  transparenzChPersons: 'Personen',
  transparenzChEntities: 'Unternehmen',
  transparenzChRelationships: 'Beziehungen',
  transparenzChCompanyInfo: 'Unternehmensinformationen',
  transparenzChName: 'Name',
  transparenzChUid: 'UID',
  transparenzChLegalForm: 'Rechtsform',
  transparenzChJurisdiction: 'Jurisdiktion',
  transparenzChAddress: 'Adresse',
  transparenzChValidFrom: 'Gültig ab',
  transparenzChRecordVersion: 'Datensatzversion',
  transparenzChSource: 'Quelle',
  transparenzChControlChain: 'Unternehmen in der Kontrollkette',
  transparenzChBeneficialOwners: 'Wirtschaftlich Berechtigte und verbundene Personen',
  transparenzChNoPersons: 'Keine Personen zurückgegeben.',
  transparenzChDateOfBirth: 'Geburtsdatum',
  transparenzChNationalities: 'Staatsangehörigkeit',
  transparenzChEmail: 'E-Mail',
  transparenzChNoRelationships: 'Keine Beziehungsdetails zurückgegeben.',
  transparenzChRelationship: 'Beziehung',
  transparenzChControlType: 'Kontrolltyp',
  transparenzChShareRange: 'Anteilsbereich',
  transparenzChRole: 'Rolle',
  transparenzChDetails: 'Details',
  transparenzChControlDetails: 'Kontrolldetails',
  transparenzChAnnotations: 'Hinweise',
  transparenzChAnnotationReason: 'Grund',
  transparenzChAnnotationStatus: 'Status',
  transparenzChUndisclosedBos: 'Nicht offengelegte wirtschaftlich Berechtigte',
  transparenzChUnsuccessfullyIdentified: 'Nicht erfolgreich identifiziert',
  transparenzChDownloadPdf: 'PDF herunterladen',
  transparenzChGeneratingPdf: 'PDF wird erstellt…',
  transparenzChFiUidHint:
    'UID des Finanzintermediärs, der sich mit dem BO-Register verbindet (z.B. CHE123456789).',
  transparenzChFiPidHint:
    'Interne Benutzer-ID der anfragenden Person innerhalb des Finanzintermediärs (max. 36 Zeichen).',
  transparenzChCompanyUidHint: 'UID des zu prüfenden Unternehmens (z.B. CHE-123.456.789).',
  transparenzChCompareTitle: 'Datenvergleich',
  transparenzChCompareAllMatch:
    '✓ Alle geprüften Felder stimmen mit dem Transparenzregister überein.',
  transparenzChCompareMismatch: '⚠ Abweichungen festgestellt – bitte den Vergleich prüfen.',
  transparenzChCompareField: 'Feld',
  transparenzChCompareLocal: 'System',
  transparenzChCompareRegister: 'Transparenzregister',

  // Swiss BO-Register access management
  transparenzChNotConfigured:
    'Für das Schweizer Transparenzregister sind keine Zugangsdaten hinterlegt. Bitte in den Einstellungen die ePortal-Zugangsdaten eintragen.',
  transparenzChReauthRequired:
    'Der Refresh-Token für das Schweizer Transparenzregister ist abgelaufen. Bitte im ePortal ein neues Token-Set generieren und erneut hinterlegen.',
  transparenzChTokenServiceUnavailable:
    'Der Key Manager des Schweizer Transparenzregisters ist derzeit nicht erreichbar. Bitte später erneut versuchen.',
  transparenzChNotAuthorized:
    'Der Geschäftspartner ist noch nicht für das BO-Register freigeschaltet. Bitte den Zugang im ePortal prüfen.',
  transparenzChConnectionRequestFailed:
    'Die Anfrage an das Schweizer Transparenzregister ist fehlgeschlagen.',
  transparenzChConnectionSaved: 'Zugangsdaten für das Schweizer Transparenzregister gespeichert.',
  transparenzChSettingsTitle: 'Schweizer Transparenzregister (BO-Register)',
  transparenzChSettingsHint:
    'Zugangsdaten aus dem ePortal API Selfservice Portal – im ePortal auch „Customer Key“ (Client-ID) und „Customer Secret“ (Client-Secret) genannt.',
  transparenzChMenuTitle: 'Anbindung Transparenzregister',
  transparenzChClientId: 'Client-ID',
  transparenzChClientSecret: 'Client-Secret',
  transparenzChRefreshToken: 'Initialer Refresh-Token',
  transparenzChConnected: 'Verbunden',
  transparenzChNeedsReauth: 'Token abgelaufen – neues Token-Set erforderlich',
  transparenzChSave: 'Speichern',
  transparenzChDisconnect: 'Verbindung trennen',
  transparenzChNotConnected: 'Nicht verbunden',

  otherButtons: 'Andere',

  //topograph
  topographModalWarning:
    'Nicht genügend Guthaben für diese Bestellung. Bitte laden Sie Guthaben auf oder entfernen Sie Positionen.',
  topographGraphConfigure: 'Eigentümerstruktur konfigurieren',
  topographGraphBudgetHelp:
    'Maximale Punkte für die Analyse der Eigentümerstruktur. Höhere Punktzahlen ermöglichen tiefere Durchsuchungen.',
  topographGraphConfirm: 'Übernehmen',
  topographSucess: 'Bestellung erfolgreich!',
  topographDocumentEmail:
    'Die Dokumente werden verarbeitet und per E-Mail benachrichtigt, sobald sie verfügbar sind.',
  topographAccessText: 'Bitte geben Sie Ihren PIN-Code ein, um Unternehmensdaten und Dokumente.',
  topographGraphData: 'Diagrammdaten (Rohdaten) herunterladen',
  costWarning: 'Die Nutzung dieses Services ist mit zusätzlichen Kosten verbunden.',
  stammdatenCostWarning: 'Das Anlegen eines neuen Stammdatensatzes ist kostenpflichtig.',
  kybWarningText:
    'Die KYB-Unternehmensdatenabfrage ist vor allem für Unternehmen im EU-Raum vorgesehen.\nFür Schweizer Unternehmen empfehlen wir die Abfrage im Handelsregister.',

  firmennameOderNummer: 'Firmenname oder Nummer',
  mind2ZeichenEingeben: 'Mind. 2 Zeichen eingeben...',

  activityDetails: 'Aktivitätsdetails',
  pointsUsed: 'Verbrauchte Punkte',
  userName: 'Benutzername',
  time: 'Uhrzeit',

  excelImport: 'Excel - Import',
  connectWith: 'Verbinden mit',

  importData: 'Daten importieren',

  invalidDate: 'Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.',

  // Vertec
  vertecIntegration: 'Vertec Integration',
  vertecMenuTitle: 'Vertec Anbindung',
  vertecSettingsTitle: 'Vertec Anbindung',
  vertecSettingsHint:
    'Verbinden Sie Ihr Vertec-Konto, um Kundendaten zu importieren. Erstellen Sie einen API-Token in Vertec und geben Sie ihn hier ein.',
  vertecServer: 'Vertec-Server',
  vertecApiToken: 'API-Token',
  vertecSave: 'Speichern',
  vertecConnected: 'Verbunden',
  vertecNotConnected: 'Nicht verbunden',
  vertecDisconnect: 'Verbindung trennen',
  vertecConnectionSaved: 'Vertec-Zugangsdaten gespeichert.',
  vertecAllFieldsRequired: 'Bitte füllen Sie alle Felder aus.',
  vertecTestTitle: 'Verbindung testen',
  vertecTestClass: 'Vertec-Klasse',
  vertecTestFilter: 'Filter (query_memberN/query_valueN, ids, ocl, sql)',
  vertecTestRun: 'Daten abrufen',
  vertecTestCount: 'Anzahl Datensätze',
  vertecTestFailed: 'Abruf der Testdaten fehlgeschlagen.',
  vertecImportTitle: 'Mandanten aus Vertec importieren',
  vertecImportDescription: 'Wählen Sie, ob Firmen oder Personen geladen werden sollen.',
  vertecImportTypeCompanies: 'Firmen',
  vertecImportTypePersons: 'Personen',
  vertecLoadCandidates: 'Laden',
  vertecLoadingCandidates: 'Wird geladen...',
  vertecLoadCandidatesFailed: 'Daten konnten nicht geladen werden.',
  vertecNoCandidates: 'Keine Einträge gefunden.',
  vertecImportSelected: 'Ausgewählte importieren',
  vertecImporting: 'Wird importiert...',
  vertecImportResult: 'Ergebnis',
  vertecImportFailed: 'Import fehlgeschlagen.',
  zipCode: 'Postleitzahl',
  streetAddress: 'Straße und Hausnummer',
  contacts: 'Kontakte',
  optional: 'optional',
  addContact: 'Kontakt hinzufügen',

  // microsoft
  logInWithMicrosoft: 'Mit Microsoft anmelden',
  microsoftSigningIn: 'Microsoft-Anmeldung wird geöffnet...',
  microsoftAuthenticationFailed: 'Die Anmeldung mit Microsoft ist fehlgeschlagen.',
  microsoftAuthenticationInvalid:
    'Die Microsoft-Anmeldung ist ungültig. Bitte versuchen Sie es erneut.',
  microsoftAuthenticationExpired:
    'Die Microsoft-Anmeldung ist abgelaufen. Bitte versuchen Sie es erneut.',
  microsoftAuthenticationStateMismatch: 'Die Microsoft-Anmeldung konnte nicht verifiziert werden.',
  microsoftIdentityNotLinked:
    'Dieses Microsoft-Konto ist noch nicht mit einem Benutzerkonto verknüpft.',
  microsoftEmailMismatch:
    'Die E-Mail-Adresse des Microsoft-Kontos stimmt nicht mit der E-Mail-Adresse Ihres Benutzerkontos überein. Die Anmeldung wurde abgelehnt.',
  microsoftTenantMissing: 'Die Microsoft-Anmeldung konnte keinem Mandanten zugeordnet werden.',
  microsoftPopupBlocked: 'Das Microsoft-Anmeldefenster wurde vom Browser blockiert.',
  microsoftNotConfigured:
    'Die Microsoft-Anmeldung ist für diesen Mandanten nicht konfiguriert. Bitte hinterlegen Sie in den Einstellungen Client-ID und Client-Secret.',
  microsoftSharePointNotConfigured:
    'Die Microsoft 365 / SharePoint-Integration ist für diesen Mandanten nicht konfiguriert. Bitte hinterlegen Sie in den Einstellungen die Client-ID und das Client-Secret der SharePoint-App-Registrierung.',
  microsoftMenuTitle: 'Microsoft-Anmeldung (SSO)',
  microsoftSsoSettingsTitle: 'Microsoft-Anmeldung (SSO)',
  microsoftSsoSettingsHint:
    'Bitte geben Sie die Client-ID, die Mandanten-ID (Verzeichnis-ID) und den Client-Secret-Wert ein.',
  microsoftSsoGuide: 'Anleitung: Microsoft-App erstellen',
  microsoftSsoClientId: 'Client-ID (Anwendungs-ID)',
  microsoftSsoTenantId: 'Mandanten-ID (Verzeichnis-ID)',
  microsoftSsoClientSecret: 'Client-Secret',
  microsoftSsoRedirectUri: 'Weiterleitungs-URI (als Web-Redirect-URI in Microsoft registrieren)',
  microsoftSsoConnected: 'Konfiguriert',
  microsoftSsoNotConnected: 'Nicht konfiguriert',
  microsoftSsoSave: 'Speichern',
  microsoftSsoDisconnect: 'Verbindung trennen',
  microsoftSsoAllFieldsRequired: 'Bitte Client-ID, Mandanten-ID und Client-Secret eingeben.',
  microsoftSsoConnectionSaved: 'Microsoft-Zugangsdaten gespeichert.',
  microsoft365: 'Microsoft 365',
  connectMicrosoft365: 'Microsoft 365 verbinden',
  microsoftConnecting: 'Microsoft 365 wird verbunden...',
  microsoftConnected: 'Verbunden',
  microsoftConnectedSuccessfully: 'Microsoft 365 wurde erfolgreich verbunden.',
  microsoftConnectionDescription:
    'Jeder Benutzer verbindet sein eigenes Microsoft-Konto, um auf seine eigenen SharePoint-Dateien zuzugreifen.',
  microsoftDisconnect: 'Verbindung trennen',
  microsoftDisconnected: 'Microsoft 365 wurde getrennt.',
  microsoftTestConnection: 'Verbindung testen',
  microsoftConnectionOk: 'Die Microsoft 365-Verbindung ist aktiv.',
  microsoftTenant: 'Tenant-ID',

  // Microsoft 365 / SharePoint app registration (separate from SSO)
  microsoftSharePointAppMenuTitle: 'Microsoft 365 / SharePoint',
  microsoftSharePointAppSettingsTitle: 'Microsoft 365 / SharePoint (App-Registrierung)',
  microsoftSharePointAppSettingsHint:
    'Bitte geben Sie die Client-ID, die Mandanten-ID (Verzeichnis-ID, optional) und den Client-Secret-Wert ein.',
  microsoftSharePointAppClientId: 'Client-ID (Anwendungs-ID)',
  microsoftSharePointAppTenantId: 'Mandanten-ID',
  microsoftSharePointAppClientSecret: 'Client-Secret',
  microsoftSharePointAppRedirectUri:
    'Weiterleitungs-URI (als Web-Redirect-URI in Microsoft registrieren)',
  microsoftSharePointAppConnected: 'Konfiguriert',
  microsoftSharePointAppNotConnected: 'Nicht konfiguriert',
  microsoftSharePointAppSave: 'Speichern',
  microsoftSharePointAppDisconnect: 'Verbindung trennen',
  microsoftSharePointAppAllFieldsRequired: 'Bitte Client-ID und Client-Secret eingeben.',
  microsoftSharePointAppConnectionSaved: 'SharePoint-Zugangsdaten gespeichert.',

  // SharePoint
  addFromSharePoint: 'Aus SharePoint hinzufügen',
  selectSharePointFile: 'SharePoint-Datei auswählen',
  sharePointFolderEmpty: 'Dieser Ordner ist leer.',
  sharePointSite: 'SharePoint-Seite',
  sharePointSiteConfigured: 'Konfigurierte Seite',
  sharePointSaveSite: 'Seite speichern',
  sharePointSiteSaved: 'SharePoint-Seite wurde gespeichert.',
  sharePointSiteNotConfigured:
    'Für diesen Mandanten ist noch keine SharePoint-Seite konfiguriert. Bitte konfigurieren Sie die Seite in den Profil-Einstellungen.',
  sharePointLinkedFiles: 'Verknüpfte SharePoint-Dateien',
  sharePointLastModified: 'Zuletzt geändert',
  sharePointReviewedOn: 'Geprüft am',
  sharePointFileLinked: 'SharePoint-Datei wurde verknüpft.',
  sharePointFileNotAccessible: 'Auf diese SharePoint-Datei kann nicht zugegriffen werden.',
  sharePointFileAccessDenied:
    'Sie haben derzeit keine Berechtigung für diese SharePoint-Ressource. Bitte prüfen Sie Ihre Microsoft 365-Berechtigungen.',
  sharePointFileNotFound: 'Die verknüpfte SharePoint-Datei wurde gelöscht oder verschoben.',
  sharePointGraphUnavailable:
    'SharePoint ist derzeit nicht erreichbar. Bitte später erneut versuchen.',
  sharePointItemIsFolder: 'Ordner können nicht als Datei verknüpft werden.',
  sharePointFileChanged:
    'Die SharePoint-Datei wurde seit der Verknüpfung geändert. Bitte die aktuelle Version prüfen.',
  sharePointComputeHash: 'SHA-256-Prüfsumme berechnen',
  sharePointContentHash: 'SHA-256-Prüfsumme',
  sharePointHashComputed: 'SHA-256-Prüfsumme wurde berechnet.',
  sharePointCopyToTool: 'Kopie in DS|Kyc speichern',
  sharePointFileCopied: 'Kopie wurde in DS|Kyc gespeichert.',
  sharePointUploadToSharePoint: 'In SharePoint speichern',
  sharePointDocumentUploaded: 'Dokument wurde in SharePoint gespeichert.',
  sharePointUploadSourceMissing: 'Das ausgewählte Dokument wurde nicht gefunden.',
  sharePointFileInvalid: 'Die SharePoint-Datei hat keinen gültigen Dateinamen.',
  sharePointFileTooLarge: 'Die Datei ist zu gross.',
  clientAccessDenied: 'Kein Zugriff auf dieses Projekt.',
  sharePointTenantMismatch:
    'Die SharePoint-Datei gehört zu einem anderen Microsoft-Tenant als Ihre aktuelle Verbindung.',
  sharePointSiteMissing: 'SharePoint-Seite ist nicht angegeben.',
  sharePointSiteInvalid: 'Die angegebene SharePoint-Seite ist ungültig.',
  sharePointItemMissing: 'SharePoint-Element ist nicht angegeben.',
  microsoftConnectionNotFound: 'Microsoft 365 ist nicht verbunden. Bitte zuerst verbinden.',
  microsoftConnectionExpired:
    'Die Microsoft 365-Verbindung ist abgelaufen oder wurde entzogen. Bitte verbinden Sie Microsoft 365 erneut.',
  microsoftReconnect: 'Microsoft 365 erneut verbinden',
  microsoftDisabled: 'Die Microsoft-Integration ist derzeit deaktiviert.',
  microsoftConnectRequiresAuthentication:
    'Bitte melden Sie sich an, um Microsoft 365 zu verbinden.',
  microsoftConnectionCouldNotBeSaved:
    'Microsoft 365 konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  microsoftFrontendOriginMissing:
    'Die Microsoft-Anmeldung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
  microsoftFrontendOriginInvalid:
    'Die Microsoft-Anmeldung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
  invalidSharePointFileId: 'Die angegebene SharePoint-Datei ist ungültig.',
  invalidMicrosoftConnectionId: 'Die angegebene Microsoft-365-Verbindung ist ungültig.',
  sharePointFileCouldNotBeSaved:
    'Die SharePoint-Datei konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  sharePointSiteCouldNotBeSaved:
    'Die SharePoint-Seite konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
}
export default de
